import '../styles/globals.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

export default function App({ Component, pageProps }) {
  useEffect(() => {
    import ("bootstrap/dist/js/bootstrap");
  }, []);
  return (
  <>
  <title>Shankar IAS Academy</title>
  <Component {...pageProps} />
   <ToastContainer
   theme='dark'
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        draggable={false}
        pauseOnVisibilityChange
        closeOnClick
        pauseOnHover
      /></>)
}
                               